/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { store } from '../../store'
import * as globalSearchUrl from './urls/global-search'
import ApiClient from '../services/axiosClient'

const singletonApiInstance = new ApiClient()

export const globalProductSearch = async (param = {}) => {
  const {
    user: { data }
  } = store.getState()
  const endUrl = globalSearchUrl.globalProductSearch()
  try {
    const res = await singletonApiInstance.getRequest(endUrl, param, {
      Authorization: `Token ${data?.token}`,
      'Customer-Id': data?.uid
    }, false, true)
    if (res?.status === 200) {
      return res
    } else {
      throw new Error()
    }
  } catch (error) {
    return error
  }
}

export const inStoreProductSearch = async (storeId, param = {}) => {
  const {
    user: { data }
  } = store.getState()
  const endUrl = globalSearchUrl.inStoreProductSearch(storeId)
  try {
    const res = await singletonApiInstance.getRequest(endUrl, param, {
      Authorization: `Token ${data?.token}`,
      'Customer-Id': data?.uid
    }, true)
    if (res?.status === 200) {
      return res
    } else {
      throw new Error()
    }
  } catch (error) {
    return error
  }
}
